export default __webpack_public_path__ + "static/data-vis-color-role-dont-51edfb21ec3b41e8637d63a760e02f9836f304bc17c86624a700db16eac617dc.png";